import { useNavigate } from '@tanstack/react-router'
import { PayPeriodOverview } from '@/common/components/pay-period-overview/PayPeriodOverview'
import { useManagerTimesheetSummary } from '@/common/hooks/useManagerTimesheets'
import { useNotifications } from '@/common/hooks/useNotifications'
import { NotificationSection } from '@/common/components/notification-section/NotificationSection'
import type { EmployeeTimesheetStatus } from '@/common/hooks/useAdminTimesheetSummary'

export function ManagerDashboard() {
  const navigate = useNavigate()
  const { data: notifications } = useNotifications()

  const handleEmployeeClick = (emp: EmployeeTimesheetStatus) => {
    if (emp.timesheet_id) {
      navigate({ to: '/manager/review/$timesheetId', params: { timesheetId: String(emp.timesheet_id) } })
    }
  }

  return (
    <>
      <PayPeriodOverview
        title="Team Timesheets"
        useData={useManagerTimesheetSummary}
        enableGrouping={false}
        onEmployeeClick={handleEmployeeClick}
      />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 32px 32px' }}>
        <NotificationSection notifications={notifications ?? []} />
      </div>
    </>
  )
}
